import { Children, useEffect, useRef } from 'react';
import { useDeviceType } from '@vfit/shared/hooks';
import { Swiper, SwiperSlide } from 'swiper/react';
import { EffectCards, FreeMode, Keyboard, Mousewheel, Pagination } from 'swiper';
import { ImageDivider, CustomText } from '@vfit/shared/atoms';
import { Fade } from 'react-awesome-reveal';
import {
  ConnectionCardsContainer,
  ConnectionCardsProduct,
  ConnectionCardsText,
  DisclaimerContainer,
} from './connectionCards.style';
import { getSlideSize, updateAllHeight } from './connectionCards.utils';
import { IConnectionCardsProps } from './connectionCards.models';
import PassionCard from '../PassionCard/passionCard';
import { stringToAsciiCode } from '@vfit/shared/themes';

const ConnectionCards = ({
  topText,
  containerStyle,
  description,
  slides,
  divider,
  disclaimer,
}: IConnectionCardsProps) => {
  const { isMobile, isTablet } = useDeviceType();
  const connectionElement = useRef<HTMLDivElement>(null);

  const setHeights = () => {
    if (connectionElement.current) {
      updateAllHeight(connectionElement.current);
    }
  };

  useEffect(() => {
    setTimeout(() => {
      setHeights();
    }, 100);
  }, [slides]);

  const swiperProduct = (type: 'slide' | 'cards') => (
    <Swiper
      key={Math.random().toString()}
      slidesPerView="auto"
      effect={type}
      cardsEffect={{
        rotate: true,
        slideShadows: false,
      }}
      mousewheel={{
        forceToAxis: true,
      }}
      spaceBetween={0}
      freeMode={false}
      centeredSlides={isMobile}
      keyboard
      pagination={{
        clickable: true,
      }}
      modules={[Pagination, FreeMode, Mousewheel, Keyboard, EffectCards]}
    >
      {Children.toArray(
        slides?.map((slide, index) => {
          let marginLeft = index === 0 ? 80 : 0;
          if (index === 0 && isMobile) marginLeft = 0;
          const customSize = getSlideSize(index, isMobile, isTablet);
          return (
            <SwiperSlide
              style={{
                marginLeft,
                borderRadius: '0px',
                ...customSize,
              }}
            >
              <ConnectionCardsProduct>
                <PassionCard
                  key={stringToAsciiCode(index.toString())}
                  id={slide.id}
                  image={slide.image}
                  title={slide.title}
                  description={slide.description}
                  titleAboveImg={slide.category}
                  action={slide.action}
                  pills={slide.pills}
                  actionNavigationUrl={slide.actionNavigationUrl}
                />
              </ConnectionCardsProduct>
            </SwiperSlide>
          );
        })
      )}
    </Swiper>
  );

  return (
    <>
      {topText && <CustomText text={topText} />}
      <ConnectionCardsContainer ref={connectionElement} style={{ ...containerStyle }}>
        {description && (
          <ConnectionCardsText>
            <CustomText text={description} />
          </ConnectionCardsText>
        )}
        {isMobile && swiperProduct('cards')}
        {!isMobile && swiperProduct('slide')}
      </ConnectionCardsContainer>
      {disclaimer && (
        <DisclaimerContainer>
          <CustomText text={disclaimer} lineHeight={22} size={16} textAlign="left" />
        </DisclaimerContainer>
      )}
      {divider?.image && (
        <Fade direction="up" triggerOnce>
          <ImageDivider image={divider?.image} alt={divider.text || ''} />
        </Fade>
      )}
    </>
  );
};

export default ConnectionCards;

